import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    budget: 1,
    selectedBlockchain: 'ETH',
    foundToken: null,
    promoterWalletAddress: '',
    isLoading: false,
    error: null
};

const budgetSlice = createSlice({
    name: 'budget',
    initialState,
    reducers: {
        setBudget: (state, action) => {
            state.budget = action.payload;
        },
        setSelectedBlockchain: (state, action) => {
            state.selectedBlockchain = action.payload;
        },
        setFoundToken: (state, action) => {
            state.foundToken = action.payload;
        },
        clearFoundToken: (state) => {
            state.foundToken = null;
        },
        setPromoterWalletAddress: (state, action) => {
            state.promoterWalletAddress = action.payload;
        },
        setLoading: (state, action) => {
            state.isLoading = action.payload;
        },
        setError: (state, action) => {
            state.error = action.payload;
        },
        resetBudgetState: (state) => {
            state.budget = 1;
            state.selectedBlockchain = 'ETH';
            state.foundToken = null;
            state.promoterWalletAddress = '';
            state.isLoading = false;
            state.error = null;
        }
    }
});

export const {
    setBudget,
    setSelectedBlockchain,
    setFoundToken,
    clearFoundToken,
    setPromoterWalletAddress,
    setLoading,
    setError,
    resetBudgetState
} = budgetSlice.actions;

export default budgetSlice.reducer;
